import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {loadEmployees, newEmployee} from '../actions/SearchActionCreators';
import {connectToStores} from 'fluxible-addons-react';
import EmployeeResults from './EmployeeResults';
import debounce from 'lodash.debounce';
import FontAwesome from 'react-fontawesome';
import {intlShape, FormattedMessage} from 'react-intl';
import MessageDefinitions from '../i18n/MessageDefinitions';

@connectToStores(['LoginStore'], (context, props) => {
  const LoginStore = context.getStore('LoginStore');

  return {
    initialSearchValue: LoginStore.getEmployeeSearchValue(),
    processing: LoginStore.isProcessing(),
    employees: LoginStore.getEmployees()
  };
})
class Search extends Component {
  static propTypes = {
    initialSearchValue: PropTypes.string.isRequired,
    processing: PropTypes.bool.isRequired,
    employees: PropTypes.array
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      searchValue: this.props.initialSearchValue,
      initiatedSearch: false
    };
    this.searchValueChanged = this.searchValueChanged.bind(this);
    this.newProfileClicked = this.newProfileClicked.bind(this);
    this.loadEmployees = debounce(searchValue => {
      this.context.executeAction(loadEmployees, {
        searchValue
      });
      this.setState({
        ...this.state,
        initiatedSearch: true
      });
    }, 500);
  }

  searchValueChanged(event) {
    const searchValue = event.target.value || '';
    this.setState({
      ...this.state,
      searchValue,
      initiatedSearch: this.props.processing
    });
    this.loadEmployees(searchValue);
  }

  newProfileClicked() {
    this.context.executeAction(newEmployee, {});
  }

  render() {
    const {searchValue, initiatedSearch} = this.state;
    const {intl} = this.context;
    const {employees = []} = this.props;

    const searchSpinner = this.props.processing
      ? <div className="search-loading">
        <FontAwesome name="refresh" spin/>
      </div>
      : null;

    const completedSearch = initiatedSearch && !this.props.processing;

    const newProfileButton = !this.props.processing
      ? <div className="newProfile">
        <div className="text-center">
          OR
        </div>
        <div className="text-center mb-3 m-b-1">If you have not used this application before, click
          "<FormattedMessage {...MessageDefinitions.newProfile} />" below to create a profile.
        </div>
        <button className="btn btn-secondary" onClick={this.newProfileClicked}>
          <FormattedMessage {...MessageDefinitions.newProfile} /> <FontAwesome name="plus-circle"/></button>
      </div>
      : null;

    const employeeResults = searchValue ? <EmployeeResults completedSearch={completedSearch}/> : null;

    return <div className="employee-login-search">
      <div className="form-body">
        <div className="form-group search-form">
          <label htmlFor="employeeLoginSearchBox" className="search-label form-label">Find your profile</label>
          <input type="search"
                 id="employeeLoginSearchBox"
                 className="form-control search-box"
                 placeholder={intl.formatMessage(MessageDefinitions.findProfilePlaceholder)}
                 value={searchValue}
                 onChange={this.searchValueChanged}/>
          <div>
            <em>
              <FormattedMessage {...MessageDefinitions.searchText} />
            </em>
          </div>
        </div>
        {employeeResults}
        {newProfileButton}
        {searchSpinner}
      </div>
    </div>;
  }

}

export default Search;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/Search.js
 **/